/**
 * The facet keys and values the sites list's filter rail is built from.
 *
 * Internal identifiers, never shown - the headings the rail renders come from `filterFacets` in
 * `view-sites.ts`, and the words beside each box come from the state-colour registry and the
 * glossary, so the rail cannot spell a state or an operation type differently from the row it
 * narrows to.
 *
 * THEY LIVE IN THEIR OWN MODULE BECAUSE THE JOURNEYS ADDRESS THE RAIL BY THEM, the same reason
 * `company-list-facets.ts` gives: a journey that retyped `'types'` would keep compiling after a
 * rename and fail on a timeout naming a missing checkbox rather than naming the rename.
 *
 * And for the same mechanical reason as its sibling: the Playwright suite is type-checked under
 * `tsconfig.e2e.json`, which is Node-side and carries no Vite client types, so importing the page
 * itself would pull `?inline` stylesheets and `import.meta.env` into a compilation that cannot
 * resolve any of it. THIS MODULE THEREFORE IMPORTS NOTHING, and must stay that way.
 *
 * A SEPARATE MODULE FROM THE COMPANY LIST'S, not a shared one. The two screens narrow different
 * subjects: a company's operating stop is "Blocked" and a site's is "Inactive"
 * (`STATE_DOMAINS.companyOperating` versus `siteOperating`), so the off value differs even where
 * the keys read alike. Sharing the constants would tie two lists that are free to diverge, which
 * is the domain-enums-stay-separate rule applied to the controls that render them.
 */

export const FACET_OPERATING = 'operating';
export const FACET_TYPES = 'types';

/**
 * Values of the operating-status facet.
 *
 * `'inactive'`, matching the word the site badge shows: `siteOperating` labels its off state
 * "Inactive", and an identifier that disagrees with the label it renders is a trap for the next
 * person reading the filter state in a debugger.
 */
export const OPERATING_ACTIVE = 'active';
export const OPERATING_INACTIVE = 'inactive';
